import React from 'react';
import { get } from 'lodash';
import InstagramHandler from './handlers/InstagramHandler';

const URLRedirectHandler = (props) => {
  const location = get(props, 'location', {});
  const params = new URLSearchParams(location.search);

  // Extract 'context' and remove it from params
  let context = params.get('context');
  context = context && context.toLowerCase();
  params.delete('context'); // Keep the URL clean

  // Extract 'code' from the URL for Instagram OAuth
  const code = params.get('code');
  if (code) {
    // Redirect to InstagramHandler with the code
    return <InstagramHandler code={code} params={params} />;
  }

  // Extract 'target' from the redirection URL
  const target = params.get('target');
  if (target) {
    // Attempt to open the app using an invisible iframe
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = target;
    document.body.appendChild(iframe);

    // Wait for a longer delay (e.g., 1000 ms) to give time for the deep link to work
    setTimeout(() => {
      // If the page is still visible, the deep link likely failed
      if (document.visibilityState === 'visible') {
        // Fallback: redirect using window.location.href
        window.location.href = target;
      }
      // Otherwise, do nothing so the app remains open
    }, 1000);
  }

  // Function to render appropriate handler
  const renderHandler = () => {
    switch (context) {
      case 'ig':
        return <InstagramHandler {...props} params={params} />;
      case 'wb':
        return;
      default:
        return;
    }
  };

  return <>{renderHandler()}</>;
};

export default URLRedirectHandler;
